<template>
  <div class>
    <el-dialog title width="500px" class="repair-dialog" :visible.sync="dialogHide" :before-close="handleClose" :close-on-click-modal='false'>
      <div slot="title">
        <span>{{payPlatform == 'wxpay' ? '微信支付':'请使用微信、支付宝、云闪付APP扫码支付'}}</span>
      </div>
      <div v-if="isType == ''">
        <div class="center">
          <div class="fontSize16">付款金额</div>
          <div class="order-price">￥{{form.realPayAmount}}</div>
          <vue-qr v-if="form.url" :text="form.url" :margin="0" colorDark="#000" colorLight="#fff" :logoScale="0.3" :size="230"></vue-qr>
        </div>
        <div class="flex-row mt20">
          <div class="infos w100">温馨提示：</div>
          <div class="f14 allColors">请在5分钟内完成付款，以免订单超时。<span class="moneys" v-if="form.orderType == 'shopManage'">支付成功后门店服务立即生效，生效后不支持退款</span> <br /><span v-if="tips.length > 0">{{ tips[0] }}</span></div>
		</div>
		<div class="flex-row" v-if="form.orderType== 'shopManage'||form.orderType== 'sms'||form.orderType== 'packages'">
		  <div class="infos w100"></div>
		  <div class="f14">支付即视为同意 <span style="color: #409eff;cursor: pointer;" @click="openDialog" >《订购须知》</span></div>
		</div>
      </div>
      <div class="center" v-else-if="isType == 'timeout'">
        <div class="fontSize16">付款金额</div>
        <div class="order-price">￥{{form.realPayAmount}}</div>
        <div class="qr-code">
          <vue-qr v-if="form.url" :text="form.url" :margin="0" colorDark="#000" colorLight="#fff" :logoScale="0.3" :size="230"></vue-qr>
          
          <div class="vueQr-code">
            <div class="mb10">{{isType == 'timeout' ? '支付超时':'支付失败'}}</div>
            <el-button @click="refresh">点击刷新重新支付</el-button>
          </div>
        </div>
      </div>
      <div class="center" v-else-if="isType == 'success'">
        <div><img src="../../../assets/images/new/wechant-success.png" alt=""></div>
        <div class="fontSize success-text">订购成功</div>
        <div class="fontSize16 color999">页面将在{{timeStep}}秒内自动关闭</div>
      </div>
    </el-dialog>
	<div class="tip">
		<el-dialog title="订购须知" width="500px" class="repair-dialog" :visible.sync="tipDialogVisible" :before-close="changeClose" :close-on-click-modal='false'>
			<div>
				<p class="p10">1.门店服务到期后，将无法进行下单、充值、开卡等收银操作</p>
				<p class="p10">2.短信剩余条数为0时，将无法发送会员注册、修改密码、消费通知等一切短信通知</p>
				<p class="p10">3.门店服务订购成功后，门店服务有效期=原门店服务到期时间+本次订购的服务时长，如原服务到期时间为2025年2月28日，续费1个月，门店服务有效期为2025年3月28日</p>
				<p class="p10">4.短信服务订购成功后，有效短信条数=原短信余量+本次订购的短信包条数；如在短信剩余50条时，订购了短信包1000条，订购完成后短信余量为1050条</p>
				<p class="p10">5.服务购买成功后立即生效，生效后不予退款</p>
			</div>
			<span slot="footer" class="dialog-footer" style="text-align: right;">
			   <el-button type="primary right-btn" @click="changeClose">确定</el-button>
			</span>
		</el-dialog> 
	</div>

  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import vueQr from 'vue-qr';
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  data() {
    return {
      form: {
        url: ''
      },
      dialogHide: false,
      orderInterval: null,
      isLunId: null,
      oldValue: 0,
      isType: '',
      timeStep: 5,
      timeStepId: null,
      payPlatform: '',
      tips: [],
	    tipDialogVisible:false,
    };
  },
  components: {vueQr},
  created() {},
  mounted() {
    this.init();
  },
  destroyed () {
    this.dialogHide = false;
    this.isType = '';
    this.oldValue = 0;
    this.timeStep = 5;
    clearInterval(this.timeStepId);
    clearInterval(this.orderInterval);
  },
  methods: {
    handleClose() {
      this.dialogHide = false;
      this.isType = '';
      this.oldValue = 0;
      this.timeStep = 5;
      clearInterval(this.isLunId)
      clearInterval(this.timeStepId);
      clearInterval(this.orderInterval);
    },
    init() {
      this.$on("set", function(row) {
        this.dialogHide = true;
        this.form = row;
		    console.log(row, 'rowssssss');
        this.getConfig()
        this.getTips()
        if (this.orderInterval) clearInterval(this.orderInterval)
        if (row.payStatus == "finish") {
          this.isType = 'success';
          if (this.timeStep <= 0) this.timeStep = 5;
            this.isLunId = setInterval(() => {
            this.timeStep = this.timeStep - 1;
            if (this.timeStep <= 0) {
              this.handleClose()
            }
          }, 1000)
        } else {
          this.isType = '';
          this.polling();
        }
      });
    },
    getConfig() { // 获取当前配置的支付方式
			this.$api.get(this.$url.shop.getConfig).then((res) => {
				if (res) {
          this.payPlatform = res.platformPayWay;
				}
			})
    },
    getTips() {
      this.$api
        .get(this.$url.companyRefund.getTips, { type: "wxPay" })
        .then((res) => {
          if (res) {
            this.tips = res;
          }
        });
    },
    polling () {
      this.orderInterval = setInterval(() => {
        this.$api.get(this.$url.shopServe.pollingGet + "?id=" + this.form.orderId).then(res => {
          if (res && res.constructor != Object) {
            if (!this.oldValue) {
              this.oldValue = new Date().getTime();
            }
            // 300000
            if (new Date().getTime() - this.oldValue >= 300000) {
              this.isType = 'timeout';
              this.oldValue = 0;
              clearInterval(this.orderInterval);
            }
            if (res == "finish") {
              this.isType = 'success';
              this.oldValue = 0;
              clearInterval(this.orderInterval);
              if (this.timeStep <= 0) this.timeStep = 5;
              this.timeStepId = setInterval(() => {
                this.timeStep = this.timeStep - 1;
                if (this.timeStep == 0) {
                  clearInterval(this.timeStepId);
                }
              },1000)
              setTimeout(() => {
                this.dialogHide = false;
                this.isType = '';
                clearInterval(this.orderInterval);
                clearInterval(this.timeStepId);
                this.$emit("change", true);
              },5000)
            }
          } else {
            clearInterval(this.orderInterval);
          }
        })
      },3000)
    },
    refresh () {
      this.form.source = 'pcCashier';
      this.form.payPlatform = this.payPlatform == 'wxpay' ? 'weixin' : 'lakala';
      this.form.itemType = this.form.orderType;
      console.log(this.form);
      this.$api.post(this.$url.shopServe.createAllPackage, encrypt(JSON.stringify(this.form))).then(res => {
        if (res) {
          this.form.url = res.payUrl;
          this.isType = "";
        }
      });
    },
    changeClose() {
      this.tipDialogVisible = false;
    },
    openDialog() {
      this.tipDialogVisible = true;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ .el-dialog {
  margin-top: 0 !important;
  top: 20%;
  border-radius: 10px;
}
.wechant {
  width: 32px;
  height: 32px;
  vertical-align: middle;
  margin-right: 10px;
}
.order-price {
  font-size: 36px;
  padding: 15px 0 40px 0;
}
/deep/ .el-dialog__header {
  height: 50px;
  box-sizing: border-box;
  line-height: 50px;
  text-align: center;
}
/deep/ .el-dialog__body {
  padding: 40px;
  color: #000;
}

/deep/ .el-dialog__footer {
  padding: 0 0 40px;
  text-align: center;
  .btn {
    font-size: 0.18rem;
  }
  .normal-btn {
    margin-right: 50px;
  }
}
.tip /deep/ .el-dialog__body {
  padding: 10px;
  color: #000;
}
.tip /deep/ .el-dialog__footer {
 text-align: right;
 padding: 10px;
}

.qr-code {
  position: relative;
}
.vueQr-code {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  opacity: 0.94;
}
.success-text {
  padding: 40px 0 22px 0;
}
.infos {
  min-width: 80px;
  color: #ff892a;
}
</style>